import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import moment from 'moment';

class TransferStationRecord extends Component {
    state = {
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    render() {
        const { visible, record } = this.state;
        const{ endTime, userMobile, userCompellation, newDoctorPost, hospitalName, hospitalDepartmentLocalName } = record || {};
        const { hospitalName: newHospitalName, hospitalDepartmentLocalName: newHospitalDepartmentLocalName } = newDoctorPost || {};
        return (
            <Modal
                title='转岗记录'
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                width="450px"
                maskClosable={false}
                width="420px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content" style={{ padding: '0 20px',color:"#333e4d",paddingLeft:"0px",lineHeight:2 }}>
                        <p>医生姓名 :  {userCompellation}<span className="ant-divider" />
                        手机号 :  {userMobile} </p>
                        <p>转岗时间 :  {moment(endTime).format('YYYY-MM-DD')} </p>
                        <p style={{fontWeight:600}}>转岗前</p>
                        <p style={{marginLeft:"15px"}}>所在医院 :  {hospitalName} </p>
                        <p style={{marginLeft:"15px"}}>所在科室 :  {hospitalDepartmentLocalName} </p>
                        <p style={{fontWeight:600}}>转岗后 </p>
                        <p style={{marginLeft:"15px"}}> 所在医院 :  {newHospitalName} </p>
                        <p style={{marginLeft:"15px"}}>所在科室 :  {newHospitalDepartmentLocalName} </p>
                </div>
            </Modal>
        )
    }
}

export default TransferStationRecord;


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/TransferStationRecord.js